import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api/client';

export default function AdminInvitesPage() {
  const [items, setItems] = useState([]);
  const [newInvite, setNewInvite] = useState(null);
  const [error, setError] = useState(null);

  const load = () =>
    api.get('/invites').then((r) => setItems(r.data)).catch(() => setError('Laden fehlgeschlagen'));

  useEffect(() => {
    load();
  }, []);

  const create = async (email, role, canChooseModel) => {
    setError(null);
    try {
      const r = await api.post('/invites', {
        email: email || null,
        role,
        can_choose_model: canChooseModel,
      });
      setNewInvite(r.data);
      load();
    } catch (e) {
      setError(e.response?.data?.error || 'Einladung fehlgeschlagen');
    }
  };

  const revoke = async (id) => {
    if (!window.confirm('Einladung wirklich widerrufen?')) return;
    await api.delete(`/invites/${id}`);
    load();
  };

  const copyLink = async (link) => {
    try {
      await navigator.clipboard.writeText(link);
    } catch (_) {
      window.alert('Kopieren fehlgeschlagen – Link manuell aus dem Feld übernehmen.');
    }
  };

  return (
    <div className="admin">
      <Link to="/">← Zurück</Link>
      <h1>Einladungen verwalten</h1>

      {error && <div className="error">{error}</div>}

      <CreateForm onCreate={create} />

      {newInvite && (
        <div className="new-invite">
          <div><strong>Neuer Einladungs-Link:</strong></div>
          <code>{newInvite.link}</code>
          <button onClick={() => copyLink(newInvite.link)}>Kopieren</button>
        </div>
      )}

      <table>
        <thead>
          <tr>
            <th>Email</th>
            <th>Rolle</th>
            <th>Modell-Wahl</th>
            <th>Status</th>
            <th>Ablauf</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {items.length === 0 && (
            <tr><td colSpan={6} className="meta">Noch keine Einladungen.</td></tr>
          )}
          {items.map((i) => (
            <tr key={i.id}>
              <td>{i.email || '—'}</td>
              <td>{i.role}</td>
              <td>{i.role === 'admin' || i.can_choose_model ? '✓' : '—'}</td>
              <td>
                <span className={`status status-${i.status}`}>{i.status}</span>
              </td>
              <td>{new Date(i.expires_at).toLocaleDateString('de-DE')}</td>
              <td>
                {i.status === 'pending' && (
                  <button onClick={() => revoke(i.id)} className="linklike">
                    Widerrufen
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function CreateForm({ onCreate }) {
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('user');
  const [canChooseModel, setCanChooseModel] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    onCreate(email, role, canChooseModel);
    setEmail('');
    setCanChooseModel(false);
  };

  return (
    <form onSubmit={submit} className="create-form">
      <input
        type="email"
        placeholder="Email (optional)"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <select value={role} onChange={(e) => setRole(e.target.value)}>
        <option value="user">Benutzer</option>
        <option value="admin">Admin</option>
      </select>
      <label className="invite-flag" title="Darf LLM-Modelle wählen, sieht Modell-Namen und Re-Analyse-Button">
        <input
          type="checkbox"
          checked={canChooseModel || role === 'admin'}
          disabled={role === 'admin'}
          onChange={(e) => setCanChooseModel(e.target.checked)}
        />
        Modell-Wahl erlaubt
      </label>
      <button type="submit">Einladung erzeugen</button>
    </form>
  );
}
